export const styles = (theme) => ({
    menuList:{
      position: 'absolute',
      width: '50vw',
      display: 'flex',
      flexDirection: 'row',
      zIndex: 10,
      margin: 0,
      marginRight: '3%',
      paddingLeft: '1%',
      paddingTop: '1%',
      paddingBottom: '1%',
      backgroundColor: theme.background.secondary,
      borderRadius: 10
    },
    tagMenu:{
      display: 'flex',
      flexWrap: 'nowrap',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
    },
    mainManu:{
      width: '100%',
      borderRight: '1px solid #ddd',
    },
    itemSeparator:{
      width: '95%',
      borderBottom: '1px solid #ddd',
    },
    subMenu: {
      width: '90%',
      marginLeft: '3%',
      marginRight: '3%',
      backgroundColor: theme.background.secondary,
    },
    professionalPath:{
      display: 'flex',
      textAlign: 'center',
      justifyContent: 'center',
      maxWidth: '95%',
      marginTop: '3%',
      marginBottom: '3%',
      color: theme.color.text.primary,
      backgroundColor: theme.background.primary,
    }
})